import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>We can pick up behaviours from all kinds of role models and this
                                                does not just happen in
                                                childhood, as many think. This tool is about <span
                                                    className="brown brownbold">how to be an effective role model </span>and
                                                aims to help
                                                you to understand which behaviours are important for you and
                                                your business, as well as providing
                                                practical advice for how to role model effectively.</p>


                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">WHAT MAKES A ROLE MODEL?</span>
                                            </div>


                                            <div className="border_subtitle">Who is your role model?</div>
                                            <p>Who have been the most significant role models in your life? Why
                                                are they role models for you?
                                                Are they all the same? Are they all different? It is worth
                                                taking a moment to consider these
                                                questions as it is often these people who will consciously, or
                                                subconsciously, guide some of your
                                                actions and behaviours.</p>
                                            <div className="border_subtitle">What is a role model?</div>
                                            <p>You have probably been told by your team or manager that you
                                                should be a ‘positive role model’
                                                or that ‘you need to display role model behaviour’. But what do
                                                people mean when they talk about
                                                role models?</p>
                                            <p>Maybe the easiest way to approach this is to consider some of the
                                                popular role models of our own
                                                and previous times, such as John F Kennedy, Nelson Mandela,
                                                Oprah Winfrey, Richard Branson
                                                and others. These people possess very different qualities yet
                                                all can be labelled role models. For
                                                example, you could say that Nelson Mandela was inspirational
                                                because he stood for what he
                                                believed in and followed a difficult course to achieve an end.
                                                You could say that Richard Branson
                                                has built a business empire from very little through sheer hard
                                                work, dedication and passion.</p>
                                            <p className="supLinesapce">What is it about these people that makes
                                                them role models? Social psychology research about
                                                leaders reveals them to be above averagely intelligent,<a
                                                    className="superscripttext supLinesapce"
                                                    href="further_info.php?course=300"><sup>2</sup></a> talkative,<a
                                                    className="superscripttext supLinesapce"
                                                    href="further_info.php?course=300"><sup>3</sup></a> considerate
                                                (people focused)
                                                and more able to define objectives and organise work (task
                                                focused).<a className="superscripttext supLinesapce"
                                                            href="further_info.php?course=300"><sup>4</sup></a> Think
                                                back to your own
                                                role models and whether they had all or some of these qualities.
                                            </p>
                                            <div className="border_subtitle">Why is being a role model
                                                important?
                                            </div>
                                            <p>Most people have aspirations or people they admire. From an early
                                                age, we learn through watching
                                                others and copying their behaviour (with both positive and
                                                adverse consequences!). Role models
                                                can influence people’s thinking and behaviour in both personal
                                                and working environments, often
                                                motivating them to take on challenges and achieve for
                                                themselves.</p>
                                            <p>According to theory,<a className="superscripttext supLinesapce"
                                                                      href="further_info.php?course=300"><sup>5</sup></a> watching
                                                the behaviour of another person can produce a ‘cognitive
                                                representation’ in the observer, whose actual behaviour may be
                                                influenced accordingly. This is a model or ‘ideal’ that we build
                                                in our mind and refer to when we are faced with taking action
                                                and decisions.</p>
                                            <p>So, it’s important that a role model’s behaviour exemplifies the
                                                values to which they subscribe. In
                                                a corporate environment, there is obvious purpose and benefit in
                                                setting examples of conduct
                                                and performance for employees to emulate.</p>
                                            <p>Aspiring role models can discover more about ‘living out values’
                                                in the tool How to identify your
                                                personal meaning'.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page3')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>


                                    </div>

                                </div>


                            </div>


                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}